{
  "verse": {
    "loading": "Loading verse...",
    "error": "Could not load verse",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "arabicUnavailable": "(Arabic not available)",
    "english": "English",
    "arabic": "العربية",
    "swapLanguage_aria": "Swap language",
    "toggleLanguage_title": "Toggle English / Arabic",
    "reflect": "Reflect",
    "reflecting": "Thinking…",
    "reflect_aria": "Generate a personal reflection connecting this verse to your intention",
    "insights": "Insights",
    "insights_aria": "Open AI Quran Insights",
    "share": "Share",
    "share_aria": "Share this verse as an image",
    "share_title": "Share this verse",
    "removeFromFavorites_aria": "Remove from favorites",
    "saveToFavorites_aria": "Save to favorites",
    "favoritesProLocked_aria": "Favorites is a Pro feature",
    "favoritesUpgrade_aria": "Upgrade to save favorites",
    "signInToSave": "Sign in to save favorites.",
    "failedToUpdateFavorites": "Failed to update favorites",
    "couldNotReflect": "Could not generate reflection",
    "shareCaption": "\"{{text}}\"\n— Surah {{surah}}, Ayah {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Image saved · verse copied",
    "imageSaved": "Verse image saved",
    "couldNotCreateImage": "Could not create the image"
  },
  "insights": {
    "panel_aria": "Quran Insights panel",
    "title": "Insights",
    "reference": "Surah {{surah}}, Ayah {{ayah}}",
    "close_aria": "Close Insights panel",
    "versePreview_aria": "Verse preview",
    "back_aria": "Back",
    "tryAgain": "Try again",
    "backTo_aria": "Back to {{ref}}",
    "copyVerse_aria": "Copy {{ref}}",
    "openingVerse": "Opening the verse…",
    "verseError": "Couldn't open the verse."
  },
  "proGate": {
    "title": "AI Quran Insights is a Pro feature",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "Unlock deep, contextual understanding of every verse.",
    "bulletAsk": "Ask any question about the verse",
    "bulletTafsir": "Instant AI-powered tafsir summaries",
    "bulletRelated": "Discover thematically related verses",
    "upgrade": "Upgrade to Pro"
  },
  "ask": {
    "heading": "Ask",
    "suggestion1": "What is the broader context of this verse?",
    "suggestion2": "How can I apply this in daily life?",
    "suggestion3": "What do classical scholars say about this?",
    "placeholder": "Ask anything about this verse…",
    "input_aria": "Ask a question about this verse",
    "submit_aria": "Submit question",
    "submit_title": "Submit (⌘↵)",
    "submit_label": "Ask",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Suggested questions",
    "error": "Couldn't get an answer.",
    "pending": "Reflecting on your question…",
    "attribution": "AI-generated answer · Not a substitute for qualified scholarship"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Get an AI-generated tafsir summary for this verse.",
    "generate": "Generate tafsir",
    "commentary": "Commentary",
    "regenerate": "Regenerate",
    "regenerate_aria": "Regenerate tafsir",
    "attribution": "AI-generated summary · Not a substitute for qualified scholarship",
    "error": "Couldn't generate the tafsir.",
    "pending": "Reading the commentary…"
  },
  "related": {
    "heading": "Related verses",
    "copied": "Copied: {{ref}}",
    "failedToCopy": "Failed to copy",
    "empty": "No related verses found.",
    "error": "Couldn't load related verses.",
    "pending": "Finding related verses…"
  },
  "favorites": {
    "panel_aria": "Favorite verses",
    "title": "Favorite Verses",
    "proLocked": "Verse favorites are a Pro feature.",
    "loading": "Loading…",
    "failedToLoad": "Failed to load favorites",
    "empty": "No favorites yet. Tap the heart on any verse to save it.",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "remove_aria": "Remove from favorites",
    "failedToRemove": "Failed to remove"
  }
}
